import { render, staticRenderFns } from "./ViewAllRecommendations.html?vue&type=template&id=88f7d2ee&scoped=true&"
import script from "./ViewAllRecommendations.vue?vue&type=script&lang=js&"
export * from "./ViewAllRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllRecommendations.scss?vue&type=style&index=0&id=88f7d2ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f7d2ee",
  null
  
)

export default component.exports